// extracted by mini-css-extract-plugin
module.exports = {"mainContent":"experience-module--mainContent--avWcs","headingFont":"experience-module--headingFont--2xSD3"};